import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a403a90"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "overlay position-absolute w-100 h-100 d-flex justify-content-center align-items-center text-center",
  width: "310px",
  height: "114px"
}
const _hoisted_4 = {
  key: 0,
  class: "w-100 mt-1 d-flex justify-content-end"
}
const _hoisted_5 = {
  key: 1,
  class: "mt-2",
  style: {"font-size":"0.985rem"}
}
const _hoisted_6 = {
  key: 2,
  class: "typed-signature-container"
}
const _hoisted_7 = { class: "d-flex d-row justify-content-end mt-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "my-2",
  style: {"font-size":"0.75rem"}
}, " By clicking \"Confirm Name\" I agree that my typed name above can be used as a digital representation of my signature. ", -1))

import { ref, Ref, watch, computed } from 'vue'
/**
 * This is a form input that allows users to sign.
 */

type SignatureProps = {
  id?: string
  name?: string
  disabled?: boolean
  processFile: (data) => Promise<void>
  errorMessage: string
}
type SignatureRef = {
  clearSignature: () => void
  saveSignature: () => { isEmpty: boolean, data: string }
  resizeCanvas: () => void
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Signature',
  props: {
    id: {},
    name: {},
    disabled: { type: Boolean },
    processFile: { type: Function },
    errorMessage: {}
  },
  emits: ["update:modelValue", "clear"],
  setup(__props: any, { emit }) {

const props = __props;





const isEmpty = ref(true)

const signaturePad: Ref<SignatureRef | null> = ref(null)

async function onBegin () {
  typedName.value = ''
  isEmpty.value = false
  signaturePad.value?.resizeCanvas()
}

async function onEnd () {
  if (signaturePad.value) {
    const { isEmpty, data } = signaturePad.value.saveSignature()
    if (!isEmpty) {
      await props.processFile?.(data)
    }
  }
}
function clear (clearError: boolean = true) {
  isEmpty.value = true
  typedName.value = ''
  signaturePad.value?.clearSignature()
  emit('update:modelValue', '')
  if (clearError) {
    emit('clear')
  }
}

// Clear signature if we get an error uploading the signature
watch(() => props.errorMessage, (errorMessage) => {
  if (errorMessage !== '') {
    clear(false)
  }
})

const isTyping = ref(false)
const typedName = ref('')
const canvas = ref<HTMLCanvasElement | null>(null)

function enableTyping () {
  clear()
  isEmpty.value = false
  isTyping.value = true
}

function cancelTyping () {
  isEmpty.value = true
  isTyping.value = false
  typedName.value = ''
}

function editTypedSignature () {
  isTyping.value = true
}

const signatureMessage = computed(() => {
  if (!isTyping.value && !typedName.value) {
    return {
      message: 'Unable to sign above?',
      actionText: 'Type your name instead.',
      actionMethod: enableTyping,
    }
  }
  else if (!isTyping.value && typedName.value) {
    return {
      message: 'Need to modify signature?',
      actionText: 'Edit e-signature.',
      actionMethod: editTypedSignature,
    }
  }
  return null
})

async function confirmName () {
  if (typedName.value && canvas.value) {
    const ctx = canvas.value.getContext('2d')
    if (ctx) {
      // Fill the canvas with the typed signature text
      const canvasWidth = canvas.value.width
      const canvasHeight = canvas.value.height
      let fontSize = canvasHeight
      let padding = fontSize * 0.1

      // Resize font and padding based on text width
      while (fontSize > 10) {
        ctx.font = `${fontSize}px Brush Script MT`
        const textWidth = ctx.measureText(typedName.value).width
        if (textWidth <= canvasWidth - padding) break
        fontSize -= 5
        padding = fontSize * 0.1
      }

      ctx.clearRect(0, 0, canvasWidth, canvasHeight)
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.fillText(typedName.value, canvasWidth / 2, canvasHeight / 2)

      const dataURL = canvas.value.toDataURL('image/png')
      await props.processFile?.(dataURL)
      isTyping.value = false
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_VueSignaturePad = _resolveComponent("VueSignaturePad")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_link = _resolveComponent("b-link")!
  const _component_b_form_input = _resolveComponent("b-form-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.errorMessage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(props.errorMessage), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["signature-container", { 'signature-container-placeholder': isEmpty.value }])
    }, [
      _createElementVNode("div", {
        class: "signature-wrapper",
        disabled: isTyping.value
      }, [
        _createVNode(_component_VueSignaturePad, {
          ref_key: "signaturePad",
          ref: signaturePad,
          class: "signature",
          width: "310px",
          height: "114px",
          options: { onBegin: onBegin, onEnd: onEnd }
        }, null, 8, ["options"]),
        (isTyping.value || typedName.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(typedName.value), 1))
          : _createCommentVNode("", true)
      ], 8, _hoisted_2),
      (!isTyping.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_b_button, {
              class: "clear-btn",
              variant: "primary",
              onClick: _withModifiers(clear, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Clear ")
              ], undefined, true),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      (signatureMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(signatureMessage.value.message) + " ", 1),
              _createVNode(_component_b_link, {
                onClick: signatureMessage.value.actionMethod
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(signatureMessage.value.actionText), 1)
                ], undefined, true),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : _createCommentVNode("", true),
      (isTyping.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_b_form_input, {
              modelValue: typedName.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((typedName).value = $event)),
              placeholder: "First and last name",
              class: "mt-2",
              maxlength: "50"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_b_link, {
                class: "mr-3",
                onClick: cancelTyping
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancel ")
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_link, {
                class: "font-weight-bold",
                disabled: !typedName.value,
                onClick: confirmName
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Confirm Name ")
                ], undefined, true),
                _: 1
              }, 8, ["disabled"])
            ]),
            _hoisted_8
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("canvas", {
        ref_key: "canvas",
        ref: canvas,
        style: {"display":"none"}
      }, null, 512)
    ], 2)
  ], 64))
}
}

})